__turbopack_context__.v({
  "card": "Tc9uwq_card",
  "cardLink": "Tc9uwq_cardLink",
  "chevron": "Tc9uwq_chevron",
  "chevronOpen": "Tc9uwq_chevronOpen",
  "footer": "Tc9uwq_footer",
  "grid": "Tc9uwq_grid",
  "image": "Tc9uwq_image",
  "media": "Tc9uwq_media",
  "mediaRegion": "Tc9uwq_mediaRegion",
  "name": "Tc9uwq_name",
  "panel": "Tc9uwq_panel",
  "panelHeader": "Tc9uwq_panelHeader",
  "panelTitle": "Tc9uwq_panelTitle",
  "parentName": "Tc9uwq_parentName",
  "placeholder": "Tc9uwq_placeholder",
  "regionName": "Tc9uwq_regionName",
  "regionsGrid": "Tc9uwq_regionsGrid",
  "ridgeline": "Tc9uwq_ridgeline",
  "tourCount": "Tc9uwq_tourCount",
});
